import ExploreCasesPies from './ExploreCasesPies';
export default ExploreCasesPies;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/ExploreCasesPies/index.js